<template>
  <div :class="{ dashboard__data: !report }">
    <template v-if="report">
      <div class="reports__row">
        <span>Потрачено бонусов:</span>
        <span>{{ spendBonusSum | roundTo2 }}</span>
      </div>
    </template>
    <template v-else>
      <app-dashboard-num
        :number="spendBonusSum ? spendBonusSum : 0"
        :comma="true"
        arrow="bot"
        icon="bonus-icon"
        color="#9E9E9E"
      />
    </template>
  </div>
</template>

<script>
import DashboardNum from '@/components/Club/ClubDashboards/DashboardNum'

export default {
  name: 'ClubDashboardsModulePurchasesSpendBonuses',
  props: {
    report: {
      type: Boolean,
      required: false,
      default: false,
    },
    id: {
      type: [Number, String],
      require: false,
    },
  },
  components: {
    'app-dashboard-num': DashboardNum,
  },
  computed: {
    clubId() {
      return this.$route.params.id || this.id
    },
    spendBonusSum() {
      return this.$store.getters[`${this.clubId}/dashboards/getSpendBonusSum`]
    },
  },
}
</script>
